import QuoteControl from './Quote';
export default QuoteControl;
